import { AppContext } from '@lightspeed-invoicing/core-client/frontend';
import React, { Component } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Icon from "../common/icon/icon.component.jsx";
import SideBar from '../common/layout/sidebar.component.jsx';
import MyAccountTabs from "../common/layout/tabs/myaccount.component.jsx";
import StandardList from '../common/listing/list.component.jsx';
import ButtonWrapper from '../common/rich-text/feature-protection-wrappers/buttonProtectionWrapper.component';
import LoadingSpinner from '../common/spinner/loading.component.jsx';
import { Guard, Permissions } from "../role/Guard.jsx";

class UserListing extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            rows: [],
            headers: [],
            searchKeywords: '',
            loading: false,
            isProSubscriptionType: false,
            enabledUsers: [],
        }
        this.handleSearchChange = this.handleSearchChange.bind(this)
        this.localizedRoleName = this.localizedRoleName.bind(this)
    }

    componentDidMount() {
        SideBar.activateMenu('account')
        this.refreshSearch()
    }

    handleSearchChange(event) {
        const target = event.target;
        this.setState({
            searchKeywords: target.value
        }, () => {
            this.refreshSearch()
        })
    }

    refreshSearch() {
        this.setState({
            loading: true,
        })

        AppContext.getApiClient().get('/users').then(r => {
            this.setState({
                enabledUsers: r.data.filter(usr => !usr.attributes.disabled),
            }, () => {
                this.setState({
                    headers: r.data.length > 0 ? this.headers() : [],
                    rows: r.data.map(q => this.row(q)),
                    loading: false,
                })
            })
        })

    }

    headers() {
        var header = [
            <FormattedMessage
                id="listing.user.list.headers.first_name_label"
                defaultMessage="First name"
            />,
            <FormattedMessage
                id="listing.user.list.headers.last_name_label"
                defaultMessage="Last name"
            />,
            <FormattedMessage
                id="listing.user.list.headers.email_label"
                defaultMessage="Email"
            />,
            <FormattedMessage
                id="listing.user.list.headers.role_label"
                defaultMessage="Role"
            />,
            <FormattedMessage
                id="listing.user.list.headers.created_at_label"
                defaultMessage="Created at"
            />,
        ]
        if (Guard.isAuthorized(Permissions.AdminMenus)) {
            header.push(
                <FormattedMessage
                    id="listing.user.list.headers.enable_users_label"
                    defaultMessage="Enable Users"
                />)
        }

        header.push(
            <FormattedMessage
                id="listing.user.list.headers.enabled_label"
                defaultMessage="Enabled"
            />
        )
        return header;
    }

    localizedRoleName(roleKey) {//returns the localized role name based on the role key
        switch (roleKey) {
            case 'admin':
                return <FormattedMessage
                    id="user.listing.admin_rolename"
                    defaultMessage="Administrator"
                />
            case 'sales-man':
                return <FormattedMessage
                    id="user.listing.salesperson_rolename"
                    defaultMessage="Salesperson"
                />
            default:
                return roleKey
        }
    }

    disableUser(event, user, disabled) {
        AppContext.getApiClient().patch('/users/' + user.id, { disabled }).then(usr => {
            this.refreshSearch()
        })
    }

    row(item) {
        var rowElem = [
            <Link to={"/users/edit/" + item.id}>{item.attributes.firstName}</Link>,
            <Link to={"/users/edit/" + item.id}>{item.attributes.lastName}</Link>,
            item.attributes.email,
            this.localizedRoleName(item.attributes.role.attributes.key),
            <FormattedDate
                year='numeric'
                month='long'
                day='numeric'
                value={new Date(item.attributes.createdAt)} />,
        ]
        Guard.isAuthorized(Permissions.AdminMenus) ? rowElem.push(
            item.id === AppContext.getUserLoggedIn().id ? '' :
                item.attributes.disabled ?
                    <ButtonWrapper
                        message={this.state.enabledUsers.length > 0 ?
                            <FormattedMessage
                                id="listing.user.list.headers.update_plan_message"
                                defaultMessage="Update your plan to increase the number of enabled users."
                            /> : ''}
                        isProtected={this.state.enabledUsers.length > 0}
                        onClick={(e) => this.disableUser(e, item, false)}
                        className={'btn btn-sm btn-outline-primary'}
                        protectedClassName={'btn btn-sm btn-outline-primary'}
                        protectionRule={(this.state.enabledUsers.length < AppContext.getAccount().attributes.maxNumberOfUsers) || (AppContext.getAccount().attributes.maxNumberOfUsers === 0)}>
                        <span>
                            <FormattedMessage
                                id="user.listing.enable_btn"
                                defaultMessage="Enable user"
                            />
                        </span>
                    </ButtonWrapper>
                    : <button className={'btn btn-sm btn-outline-secondary'}
                        onClick={(e) => this.disableUser(e, item, true)}>
                        <FormattedMessage
                            id="user.listing.disable_btn"
                            defaultMessage="Disable user"
                        />
                    </button>) : ''

        rowElem.push(
            !item.attributes.disabled ?
                <span className="badge badge-success">
                    <FormattedMessage
                        id="listing.user.list.headers.enabled_label"
                        defaultMessage="Enabled"
                    />
                </span> :
                <span className="badge badge-secondary">
                    <FormattedMessage
                        id="listing.user.list.headers.disabled_label"
                        defaultMessage="Disabled"
                    />
                </span>
        )
        return rowElem;
    }

    render() {
        let list = <StandardList
            className="row pt-3"
            headers={this.state.headers}
            rows={this.state.rows}
        />
        if (this.state.loading) {
            list = <LoadingSpinner />
        }

        return (
            <div>
                <MyAccountTabs />
                {
                    Guard.isAuthorized(Permissions.AccessAllUsers) &&
                    <div className="row ui-has-modules py-1">
                        <div className="col-12 ui-module mb-0">
                            <div className="row mb-0 justify-content-end">
                                <div className="col-3 text-align-right ">
                                    <Link to="/users/new" className="btn btn-primary">
                                        <Icon value={"plus-circle"} />
                                        <FormattedMessage
                                            id="user.listing.add_user_btn"
                                            defaultMessage="Add user"
                                        />
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {list}
            </div>
        );
    }
}

export default UserListing


// WEBPACK FOOTER //
// ./src/user/listing.component.jsx